import { Route, Routes, BrowserRouter as Router } from 'react-router';

import Main from './components/Main';
import { StatisticOptionsProvider, StatisticProvider } from './store';
import type { StatisticOptions } from './store/types';

import './styles.scss';

export const App = ({ options }: { options: StatisticOptions }) => (
  <StatisticOptionsProvider options={options}>
    <StatisticProvider>
      <Router basename={options.deepLinkBaseUrl ?? location.pathname}>
        <Routes>
          <Route path='/' element={<Main />} />
          {!!options.deepLinkBaseUrl && <Route path=':category' element={<Main />} />}
        </Routes>
      </Router>
    </StatisticProvider>
  </StatisticOptionsProvider>
);

export default App;
